import FetchStatusRepository from "../../../domain/fundamentals/fetch/FetchStatusRepository";
import NotifyRepository      from "../../../domain/fundamentals/message/notify/NotifyRepository";
import { ApiClient }         from "../../../infrastructure/configure/ApiClientConfig";
import FetchStatusDataSource from "../../../infrastructure/datasource/common/fetch/FetchStatusDataSource";
import NotifyDataSource      from "../../../infrastructure/datasource/notify/NotifyDataSource";

class GetPaymentInformation {
  private readonly fetchStatusRepository: FetchStatusRepository = new FetchStatusDataSource(this.dispatch);
  private readonly notifyRepository: NotifyRepository = new NotifyDataSource(this.dispatch);

  constructor(private readonly dispatch) {
  }

  public async execute(callbackPlanName: (value: string) => void, callbackPrice: (value: string) => void) {
    this.fetchStatusRepository.start();
    try {
      const response = await ApiClient.get("/payment/information");
      callbackPlanName(response.data.plan_name);
      callbackPrice(response.data.price);
    } catch (e) {
      this.notifyRepository.fetchFailure();
    } finally {
      this.fetchStatusRepository.finish();
    }
  }
}

export default GetPaymentInformation;
